import React from 'react';

import { Container, Segment } from 'semantic-ui-react';
import { getSystemName } from '../helpers';

const Footer = () => {
  const systemName = getSystemName();

  return (
    <Segment
      vertical
      className='modern-footer'
      style={{
        borderBottom: 'none',
      }}
    >
      <Container textAlign='center'>
        <div className='custom-footer'>
          <span>MoRouter模型超市</span>
          <span style={{margin: "0 5px"}}>{process.env.REACT_APP_VERSION}</span>
          <a href='https://beian.miit.gov.cn/' target='_blank' rel='noreferrer'>
            蜀ICP备2026009906号-1
          </a>
        </div>
      </Container>
    </Segment>
  );
};

export default Footer;
